import { useState, useRef, useEffect, Fragment } from "react";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import Camera360New from "../camera360New/Camera360New";
import stl from "./NewPostBigSlider.module.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import { trackEvents } from "@/common/events/events";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import { useLang } from "@/common/Contexts/LanguageContext";
import useIsMobile from "@hooks/useIsMobile";

const NewPostBigSlider = (props) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation(["web_post_view"]);
  const sliderRef = useRef(null);
  const thumbRef = useRef(null);
  const [Tab, setTab] = useState(0);
  const [imagesSlides, setImagesSlides] = useState(
    (props?.children || []).slice(0, 50)
  );
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [maxIteration, setMaxIteration] = useState(0);
  const [videoObject, setVideoObject] = useState(undefined);
  const [bigGallery, setBigGallery] = useState(!!props.openInFull);
  const [has360Flag, setHas360Flag] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [Loader, setLoader] = useState(true);
  const [TabChangeLoader, setTabChangeLoader] = useState(false);
  const [Movment, setMovment] = useState(0);
  const [NumberOfFingers, setNumberOfFingers] = useState(0);
  const lang = useLang();

  useEffect(() => {
    props.updateActiveIndex && props.updateActiveIndex(selectedIndex);
  }, [selectedIndex]);

  useEffect(() => {
    if (props.openInFull) {
      setBigGallery(true);
      document.body.style.overflow = "hidden";
    }
  }, [props.openInFull]);

  useEffect(() => {
    setImagesSlides(props?.children || []);
    ExtractVideo();

    setTimeout(() => {
      setLoader(false);
    }, 2000);
  }, [props?.children?.length]);

  useEffect(() => {
    ExtractVideo();
    props.getAllImages && CheckAllImages();
  }, [imagesSlides?.length]);

  useEffect(() => {
    setTimeout(() => {
      setTabChangeLoader(false);
    }, 3000);
  }, [Tab]);

  useEffect(() => {
    CheckAllImages();
    if (bigGallery) {
      const flippingFactor =
        document.querySelector("body").attributes.dir.value != "ltr" ? -1 : 1;
      if (window.innerWidth <= 1024) {
        thumbRef.current.scrollTo({
          left: flippingFactor * (selectedIndex - 1) * 114 - 120,
          behavior: "smooth",
        });
      } else {
        thumbRef.current.scrollTo({
          left: flippingFactor * (selectedIndex - 1) * 152,
          behavior: "smooth",
        });
      }
    }
  }, [selectedIndex]);

  const ExtractVideo = () => {
    if (props.video) {
      let videoItem = props.video;

      setVideoObject(videoItem);
    }
  };

  const setHas360 = (val) => {
    setHas360Flag(val);
  };

  const SlideImage = (nextOrPrev) => {
    if (nextOrPrev === "prev") {
      selectedIndex === 0
        ? setSelectedIndex(imagesSlides.length - 1)
        : setSelectedIndex(selectedIndex - 1);
    }
    if (nextOrPrev === "next") {
      selectedIndex === imagesSlides.length - 1
        ? setSelectedIndex(0)
        : setSelectedIndex(selectedIndex + 1);
    }
  };

  const CheckAllImages = () => {
    maxIteration == 0 && setMaxIteration(imagesSlides.length);
  };

  const RenderVideoBasedOnUrl = (url) => {
    return (
      <div className={stl.videoPopUp}>
        <div className={[stl.singleItem, stl.videoSingleItem].join(" ")}>
          {url.indexOf("youtu") > -1 ? (
            <div className="videoWrapper">
              <iframe
                width="100%"
                height="100%"
                src={url + "?rel=0&amp;autoplay=1&amp;mute=1"}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen=""
              ></iframe>
            </div>
          ) : (
            <video
              controls={true}
              autoplay
              muted
              playsinline
              src={url}
              type="video/mp4"
            >
              <source src={url} type="video/mp4" />
            </video>
          )}
        </div>
      </div>
    );
  };

  const GetFinalMovment = () => {
    let flippingFactor = 1;
    lang === "en" ? (flippingFactor = -1) : 1;
    return selectedIndex * 100 * flippingFactor;
  };

  // touchEvents
  const [xDown, setXDown] = useState(null);
  const [yDown, setYDown] = useState(null);

  const getTouches = (evt) => {
    return evt.touches || evt.originalEvent.touches;
  };

  function handleTouchStart(evt) {
    setNumberOfFingers(evt.touches.length);
    sliderRef.current.style.transition = "0s";
    const firstTouch = getTouches(evt)[0];
    setXDown(firstTouch.clientX);
    setYDown(firstTouch.clientY);
  }

  const handleTouchSwipe = (evt) => {
    if (NumberOfFingers === 1) {
      if (!xDown || !yDown) {
        return;
      }

      setMovment(evt.touches[0].clientX - xDown);
      CheckAllImages();

      let flippingFactor = 1;
      lang === "en" ? (flippingFactor = -1) : 1;
      let currentleft = window.innerWidth * selectedIndex * flippingFactor;

      // sliderRef.current.style.left =
      //   currentleft + evt.touches[0].clientX - xDown + "px";
    }
  };

  const handleTouchEnd = (evt) => {
    /*most significant*/
    if (NumberOfFingers === 1) {
      sliderRef.current.style.transition = "";
      // sliderRef.current.style.left = GetFinalMovment() + "%";

      if (Movment > 70 || Movment < -70) {
        const b = document.querySelector("body");
        if (Movment < 0) {
          lang === "ar" ? SlideImage("prev") : SlideImage("next");
        } else {
          lang === "ar" ? SlideImage("next") : SlideImage("prev");
        }
      }
    }
    /* reset values */
    setXDown(null);
    setYDown(null);
    setNumberOfFingers(0);
    setMovment(0);
  };

  return (
    <>
      <div
        className={[
          stl.container,
          bigGallery ? stl.bigGallShow : undefined,
          props?.hasCampaign || bigGallery ? stl.noRad : undefined,
        ].join(" ")}
      >
        <div className={stl.mobileControls}>
          <div>
            <ProgressiveImage
              waitUntilInteractive
              onClick={(e) => {
                if (props.onClose) {
                  props.onClose(e);
                } else {
                  setBigGallery(false);
                  document.body.style.overflow = "";
                  setTab(0);
                  setTabChangeLoader(true);
                  setShowVideo(false);
                }
              }}
              className={"hasEvents applyWebVevent"}
              src={CDN_LINK + "/assets/images/whitearrowBack.svg"}
              alt=""
              width={24}
              height={24}
            />
            {props.inpectionTitle && (
              <strong
                onClick={() => {
                  if (props.onClose) {
                    props.onClose();
                  } else {
                    setBigGallery(false);
                    document.body.style.overflow = "";
                    setTab(0);
                    setTabChangeLoader(true);
                    setShowVideo(false);
                  }
                }}
                className={stl.inpectionTitle}
              >
                {props.inpectionTitle}
              </strong>
            )}
          </div>
          {!props.isInpectionBlack && (
            <div>
              <div
                onClick={() => {
                  setTab(0);
                  setTabChangeLoader(true);
                }}
                className={[
                  // stl.singleTab,
                  // Tab == 0 ? stl.active : undefined,
                  Tab == 0 ? stl.mobileActiveTB : undefined,
                ].join(" ")}
              >
                {Tab == 0 ? (
                  <img
                    src={CDN_LINK + "/assets/images/ImagesBWhite.svg"}
                    alt="images"
                    width={16}
                    height={16}
                  />
                ) : (
                  <img
                    src={CDN_LINK + "/assets/images/ImagesBBlue.svg"}
                    alt="images"
                    width={24}
                    height={24}
                  />
                )}
              </div>
              {props?.showCamera360 && props?.id360 && (
                <div
                  id="hideBtnNo360Mobile"
                  onClick={() => {
                    setTab(1);
                    setTabChangeLoader(true);
                  }}
                  className={[
                    // stl.singleTab,
                    // Tab == 1 ? stl.active : undefined,
                    Tab == 1 ? stl.mobileActiveTB : undefined,
                  ].join(" ")}
                >
                  {Tab == 1 ? (
                    <ProgressiveImage
                      waitUntilInteractive
                      width={24}
                      height={24}
                      src={CDN_LINK + "/assets/images/360BWhite.svg"}
                      alt="images"
                    />
                  ) : (
                    <ProgressiveImage
                      waitUntilInteractive
                      width={24}
                      height={24}
                      src={CDN_LINK + "/assets/images/360BBlue.svg"}
                      alt="images"
                    />
                  )}
                </div>
              )}
              {props.video && (
                <div
                  onClick={() => {
                    setTab(2);
                    setTabChangeLoader(true);
                    setShowVideo(true);
                  }}
                  className={[
                    // stl.singleTab,
                    // Tab == 2 ? stl.active : undefined,
                    Tab == 2 ? stl.mobileActiveTB : undefined,
                  ].join(" ")}
                >
                  {Tab == 2 ? (
                    <ProgressiveImage
                      waitUntilInteractive
                      width={24}
                      height={24}
                      src={CDN_LINK + "/assets/images/PlayBWhite.svg"}
                      alt="images"
                    />
                  ) : (
                    <ProgressiveImage
                      waitUntilInteractive
                      width={24}
                      height={24}
                      src={CDN_LINK + "/assets/images/PlayBBlue.svg"}
                      alt="images"
                    />
                  )}
                </div>
              )}
            </div>
          )}
        </div>
        <div
          className={[
            stl.headingSection,
            "m-hide",
            props.isInpectionBlack ? stl.blackHEad : undefined,
          ].join(" ")}
        >
          <div className={[stl.upperSection].join(" ")}>
            <img
              className="hasEvents"
              src={
                props.isInpectionBlack
                  ? CDN_LINK + "/assets/images/closewhite.svg"
                  : CDN_LINK + "/assets/images/closeBslider.svg"
              }
              // width={25}
              // height={25}
              alt="close"
              onClick={(e) => {
                if (props.onClose) {
                  props.onClose(e);
                } else {
                  setBigGallery(false);
                  document.body.style.overflow = "";
                  setTab(0);
                  setTabChangeLoader(true);
                  setShowVideo(false);
                }
              }}
            />
            {props.inpectionTitle && (
              <strong
                onClick={() => {
                  if (props.onClose) {
                    props.onClose();
                  } else {
                    setBigGallery(false);
                    document.body.style.overflow = "";
                    setTab(0);
                    setTabChangeLoader(true);
                    setShowVideo(false);
                  }
                }}
                className={stl.inpectionTitle}
              >
                {props.inpectionTitle}
              </strong>
            )}
            <div>
              <strong>{props.title}</strong>
            </div>
          </div>

          <div className={[stl.tabs].join(" ")}>
            <div
              onClick={() => {
                setTab(0);
                setTabChangeLoader(true);
              }}
              className={[
                stl.singleTab,
                Tab == 0 ? stl.active : undefined,
              ].join(" ")}
            >
              <img
                src={CDN_LINK + "/assets/images/ImagesGGrey.svg"}
                alt="images"
              />
              <img
                src={CDN_LINK + "/assets/images/ImagesBBlue.svg"}
                alt="images"
              />
              <span>{t("الصور", { ns: "web_post_view" })}</span>
            </div>
            {props?.showCamera360 && props.id360 && (
              <div
                id="hideBtnNo360"
                onClick={() => {
                  setTab(1);
                  setTabChangeLoader(true);
                  trackEvents("view_360", props?.postData?.g4Data);
                }}
                className={[
                  stl.singleTab,
                  Tab == 1 ? stl.active : undefined,
                ].join(" ")}
              >
                <ProgressiveImage
                  waitUntilInteractive
                  width={24}
                  height={24}
                  src={CDN_LINK + "/assets/images/360GGrey.svg"}
                  alt="images"
                />
                <ProgressiveImage
                  waitUntilInteractive
                  width={24}
                  height={24}
                  src={CDN_LINK + "/assets/images/360BBlue.svg"}
                  alt="images"
                />
                <span>{t("مشاهدة بتقنية 360", { ns: "web_post_view" })}</span>
              </div>
            )}
            {props.video && (
              <div
                onClick={() => {
                  setTab(2);
                  setTabChangeLoader(true);
                  setShowVideo(true);
                  //  trackEvents("view_video",props?.postData?.g4_data)
                  // viewVideoEvent(props?.postData?.g4_data);
                }}
                className={[
                  stl.singleTab,
                  Tab == 2 ? stl.active : undefined,
                ].join(" ")}
              >
                <img
                  src={CDN_LINK + "/assets/images/PlayGGrey.svg"}
                  alt="images"
                />
                <img
                  src={CDN_LINK + "/assets/images/PlayBBlue.svg"}
                  alt="images"
                />
                <span>{t("مشاهدة الفيديو", { ns: "web_post_view" })}</span>
              </div>
            )}
          </div>
        </div>

        <div className={stl.bodySection}>
          <div className="tab" style={{ display: Tab != 0 ? "none" : "" }}>
            <div
              className={[
                stl.imagesSliderContainer,
                props.campaignText && !bigGallery ? stl.noRad : undefined,
                props?.hasCampaign || bigGallery ? stl.noRad : undefined,
              ].join(" ")}
            >
              <div
                ref={sliderRef}
                onTouchStart={(e) => {
                  e.touches.length === 1 && handleTouchStart(e);
                }}
                onTouchMove={(e) => {
                  e.touches.length === 1 && handleTouchSwipe(e);
                }}
                onTouchEnd={(e) => {
                  handleTouchEnd(e);
                }}
                className={stl.wrraper}
              // style={{ left: GetFinalMovment() + "%" }}
              >
                {imagesSlides.slice(0, 99).map((item, idx) => {
                  return (

                    <Fragment key={idx + "sliderItem"}>
                      <div
                        className={[
                          stl.singleItem,
                          props.campaignText && !bigGallery
                            ? stl.noRad
                            : undefined,
                          !bigGallery ? stl.noRad : undefined,
                          selectedIndex == idx ? stl.activeItem : undefined,

                          idx === selectedIndex ? stl.activeSlide : undefined,
                          idx === selectedIndex ? "activeSlide" : undefined,
                          idx > selectedIndex ? stl.nextSlide : undefined,
                          idx < selectedIndex ? stl.prevSlide : undefined,
                          selectedIndex === imagesSlides?.length - 1 &&
                            idx === 0
                            ? stl.actAsLst
                            : undefined,
                          idx === imagesSlides?.length - 1 &&
                            selectedIndex === 0
                            ? stl.actAsfirst
                            : undefined,
                        ].join(" ")}
                        onClick={() => {
                          !bigGallery &&
                            props?.postData?.g4Data &&
                            trackEvents(
                              "view_image",
                              props?.postData?.g4Data
                            );

                          setBigGallery(true);
                          window.innerWidth < 1025 &&
                            (document.body.style.overflow = "hidden");
                          CheckAllImages();
                        }}
                      >
                        <ProgressiveImage
                          hasZoom
                          progressiveSmallImage={
                            item.props["progressiveSmallImage"]
                          }
                          src={
                            bigGallery
                              ? item.props.src
                                .replace("x683", "x960")
                                .replace("x426", "x960")
                              : item.props["src"]
                          }
                          alt={item.props["alt"]}
                          loading={
                            idx == 0 ? "eager" : "lazy"

                          }
                          width={isMobile ? 430 : 720}
                          height={isMobile ? null : 446}
                        />
                      </div>
                    </Fragment>

                  );
                })}
              </div>
              {imagesSlides.length > 1 && (
                <>
                  <div
                    className={stl.nextArr}
                    onClick={() => {
                      // CheckAllImages();

                      SlideImage("prev");
                    }}
                  ></div>
                  <div
                    className={stl.prevArr}
                    onClick={() => {
                      SlideImage("next");
                    }}
                  />
                </>
              )}
              <div className={stl.enlargeNote}>{t("اضغط لتكبير الصورة", { ns: "web_post_view" })}</div>
              <div className={[stl.crntImgCC, ""].join(" ")}>
                <span>{selectedIndex + 1}</span>
                <span data-dir="rtl">/</span>
                <span data-dir="ltr">/</span>
                <span>{imagesSlides.length}</span>
              </div>

              {props.showCamera360 && (
                <div
                  className={[stl.button360, ""].join(" ")}
                  onClick={() => {
                    setTab(1);
                    setTabChangeLoader(true);
                    setBigGallery(true);
                    document.body.style.overflow = "hidden";
                    trackEvents("view_360", props?.postData?.g4Data);
                  }}
                >
                  <ProgressiveImage
                    waitUntilInteractive
                    width={24}
                    height={24}
                    src={CDN_LINK + "/assets/images/360Blue.svg"}
                    alt="icn"
                  />

                  <span className="m-hide">
                    {t("مشاهدة بتقنية 360", { ns: "web_post_view" })}
                  </span>
                </div>
              )}
              {videoObject && (
                <div
                  className={[stl.playVideoButton, ""].join(" ")}
                  onClick={() => {
                    setShowVideo(true);
                    setTab(2);
                    setTabChangeLoader(true);
                    setBigGallery(true);
                    document.body.style.overflow = "hidden";
                  }}
                >
                  <ProgressiveImage
                    waitUntilInteractive
                    width={24}
                    height={24}
                    src={CDN_LINK + "/assets/images/playBlue.svg"}
                    alt="icn"
                  />

                  <span className="m-hide">
                    {t("مشاهدة الفيديو", { ns: "web_post_view" })}
                  </span>
                </div>
              )}
              <div className={["m-show", stl.mobileDots].join(" ")}>
                {imagesSlides.map((item, idx) => {
                  return (
                    <span
                      key={"pan" + idx}
                      className={[
                        idx == selectedIndex ? stl.activeOrnge : undefined,
                        idx == selectedIndex + 3 ? stl.smalPanSlide : undefined,
                        idx > selectedIndex + 3 ? stl.hidePan : undefined,
                        idx == selectedIndex - 3 ? stl.smalPanSlide : undefined,
                        idx < selectedIndex - 3 ? stl.hidePan : undefined,
                      ].join(" ")}
                    ></span>
                  );
                })}
              </div>
            </div>

            {bigGallery && props.inpectionNote && (
              <p className={stl.inpectionNote}>
                {props.hasMultiNotes
                  ? props.inpectionNote[selectedIndex]?.note.split("-")[1]
                  : props.inpectionNote.split("-")[1]
                    ? props.inpectionNote.split("-")[1]
                    : props.inpectionNote}
              </p>
            )}
            {bigGallery && imagesSlides.length > 1 && (
              <div className={[stl.bigNumberSliderContainer].join(" ")}>
                <div className={[stl.bigNumbering].join(" ")}>
                  <span>{selectedIndex + 1}</span>{" "}
                  <span data-dir="rtl">/</span>
                  <span data-dir="ltr">/</span>{" "}
                  <span>{imagesSlides.length}</span>
                </div>
              </div>
            )}
            {bigGallery && (
              <div
                className={[
                  stl.thumbContainerNS,
                  imagesSlides.length <= 9 ? stl.centerMe : undefined,
                ].join(" ")}
                ref={thumbRef}
              >
                {imagesSlides.length > 1 &&
                  imagesSlides.map((item, idx) => {
                    return (
                      maxIteration >= idx && (
                        <React.Fragment key={idx + "thumb"}>
                          <div
                            className={[
                              stl.singlethumb,
                              selectedIndex == idx
                                ? stl.activethumb
                                : undefined,
                            ].join(" ")}
                            onClick={() => {
                              setSelectedIndex(idx);
                            }}
                          >
                            <img
                              alt={"car"}
                              src={
                                props.thumbx683
                                  ? item.props["data-mrk"]
                                    ? item.props["src"]
                                    : item.props["data-src"]
                                  : item.props["data-mrk"]
                                    ? item.props["src"]
                                      .replace("x683", "x154")
                                      .replace("x426", "x154")
                                      .replace("x960", "x154")
                                      .replace("x426", "x154")
                                    : item.props["data-src"]
                                      .replace("x683", "x154")
                                      .replace("x426", "x154")
                                      .replace("x960", "x154")
                                      .replace("x426", "x154")
                              }
                            />
                          </div>
                        </React.Fragment>
                      )
                    );
                  })}
              </div>
            )}
          </div>
          {props?.showCamera360 && props.id360 && (
            <div
              className={[
                stl.container360Tab,
                Tab == 1 ? stl.show360Cont : undefined,
              ].join(" ")}
            >
              <Camera360New
                id={props.id360}
                updateHas360={(val) => {
                  setHas360(val);
                }}
              />
            </div>
          )}
          {props.video && (
            <div style={{ display: Tab != 2 ? "none" : "" }}>
              {Tab == 2 &&
                showVideo &&
                videoObject &&
                RenderVideoBasedOnUrl(videoObject.video_link)}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default NewPostBigSlider;
